import { createContext } from 'react'
const contactsContext = createContext()
export default contactsContext